import React from 'react'
import MyButton from '../../../../../components/UI/button/MyButton'
import './style.scss'
import { Autoplay, FreeMode, Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import TypingWithGhost from './TypingWithGhost';
import GlassEffect from '../GlassEffect/GlassEffect';
export default function GenerateSection({ secondSection, handleClick, isVisible }) {

    const arrow = <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.28902 3.95699C2.08074 4.16527 2.08074 4.50296 2.28902 4.71124L5.99948 8.4217L9.70994 4.71124C9.91822 4.50296 9.91822 4.16527 9.70994 3.95699C9.50166 3.74871 9.16397 3.74871 8.95569 3.95699L5.99948 6.9132L3.04327 3.95699C2.83499 3.74871 2.4973 3.74871 2.28902 3.95699Z" fill="white" />
    </svg>

    const typingBlock = <div className="landing-generate-typing" >
        <TypingWithGhost isVisible={isVisible} />
        <div className="landing-generate-typing-bottom">
            <div className="landing-generate-typing-bottom-item" onClick={() => handleClick('prompt')}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1466_5267)">
                        <path d="M12.7998 4.00065C12.7998 3.55882 12.4415 3.20052 11.9997 3.20052H3.99967C3.55785 3.20052 3.19954 3.55882 3.19954 4.00065V12.0007C3.19954 12.4425 3.55785 12.8008 3.99967 12.8008H11.9997C12.4415 12.8008 12.7998 12.4425 12.7998 12.0007V4.00065ZM10.1331 6.00065C10.1331 5.92701 10.0733 5.86719 9.99967 5.86719H5.99967C5.92604 5.86719 5.86621 5.92701 5.86621 6.00065V10.0007C5.86621 10.0743 5.92604 10.1341 5.99967 10.1341H9.99967C10.0733 10.1341 10.1331 10.0743 10.1331 10.0007V6.00065ZM11.1995 10.0007C11.1995 10.6634 10.6624 11.2005 9.99967 11.2005H5.99967C5.33693 11.2005 4.7998 10.6634 4.7998 10.0007V6.00065C4.7998 5.33791 5.33693 4.80078 5.99967 4.80078H9.99967C10.6624 4.80078 11.1995 5.33791 11.1995 6.00065V10.0007ZM13.8662 4.13411H14.6663C14.9609 4.13411 15.1995 4.37277 15.1995 4.66732C15.1995 4.96187 14.9609 5.20052 14.6663 5.20052H13.8662V7.46745H14.6663C14.9609 7.46745 15.1995 7.7061 15.1995 8.00065C15.1995 8.2952 14.9609 8.53385 14.6663 8.53385H13.8662V10.8008H14.6663C14.9609 10.8008 15.1995 11.0394 15.1995 11.334C15.1995 11.6285 14.9609 11.8672 14.6663 11.8672H13.8662V12.0007C13.8662 13.0316 13.0306 13.8672 11.9997 13.8672H11.8662V14.6673C11.8662 14.9619 11.6276 15.2005 11.333 15.2005C11.0385 15.2005 10.7998 14.9619 10.7998 14.6673V13.8672H8.53288V14.6673C8.53288 14.9619 8.29423 15.2005 7.99967 15.2005C7.70512 15.2005 7.46647 14.9619 7.46647 14.6673V13.8672H5.19954V14.6673C5.19954 14.9619 4.96089 15.2005 4.66634 15.2005C4.37179 15.2005 4.13314 14.9619 4.13314 14.6673V13.8672H3.99967C2.96874 13.8672 2.13314 13.0316 2.13314 12.0007V11.8672H1.33301C1.03846 11.8672 0.799805 11.6285 0.799805 11.334C0.799805 11.0394 1.03846 10.8008 1.33301 10.8008H2.13314V8.53385H1.33301C1.03846 8.53385 0.799805 8.2952 0.799805 8.00065C0.799805 7.7061 1.03846 7.46745 1.33301 7.46745H2.13314V5.20052H1.33301C1.03846 5.20052 0.799805 4.96187 0.799805 4.66732C0.799805 4.37277 1.03846 4.13411 1.33301 4.13411H2.13314V4.00065C2.13314 2.96972 2.96874 2.13411 3.99967 2.13411H4.13314V1.33398C4.13314 1.03943 4.37179 0.800781 4.66634 0.800781C4.96089 0.800781 5.19954 1.03943 5.19954 1.33398V2.13411H7.46647V1.33398C7.46647 1.03943 7.70512 0.800781 7.99967 0.800781C8.29423 0.800781 8.53288 1.03943 8.53288 1.33398V2.13411H10.7998V1.33398C10.7998 1.03943 11.0385 0.800781 11.333 0.800781C11.6276 0.800781 11.8662 1.03943 11.8662 1.33398V2.13411H11.9997C13.0306 2.13411 13.8662 2.96972 13.8662 4.00065V4.13411Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1466_5267">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                Sora 2
                {arrow}
            </div>
            <div className="landing-generate-typing-bottom-item" onClick={() => handleClick('prompt')}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.7998 7.33268C10.7998 7.12051 10.7155 6.91696 10.5654 6.76693C10.4154 6.6169 10.2118 6.53255 9.99967 6.53255H8.53288V12.7995H10.7998V7.33268ZM1.86621 11.9993C1.86621 12.4412 2.22451 12.7995 2.66634 12.7995H7.46647V6.53255H1.86621V11.9993ZM11.8662 12.7995H13.333C13.7748 12.7995 14.1331 12.4412 14.1331 11.9993V3.99935C14.1331 3.55752 13.7748 3.19922 13.333 3.19922H2.66634C2.22451 3.19922 1.86621 3.55752 1.86621 3.99935V5.46615H9.99967C10.4947 5.46615 10.9693 5.66295 11.3193 6.01302C11.6694 6.36309 11.8662 6.83761 11.8662 7.33268V12.7995ZM15.1995 11.9993C15.1995 13.0303 14.3639 13.8659 13.333 13.8659H2.66634C1.63541 13.8659 0.799805 13.0303 0.799805 11.9993V3.99935C0.799805 2.96842 1.63541 2.13281 2.66634 2.13281H13.333C14.3639 2.13281 15.1995 2.96842 15.1995 3.99935V11.9993Z" fill="white" />
                </svg>

                720p
                {arrow}
            </div>
            <div className="landing-generate-typing-bottom-item" onClick={() => handleClick('prompt')}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_1466_5579)">
                        <path d="M14.1331 8.00065C14.1331 4.6133 11.387 1.86719 7.99967 1.86719C4.61233 1.86719 1.86621 4.6133 1.86621 8.00065C1.86621 11.388 4.61233 14.1341 7.99967 14.1341C11.387 14.1341 14.1331 11.388 14.1331 8.00065ZM7.46647 4.00065C7.46647 3.7061 7.70512 3.46745 7.99967 3.46745C8.29423 3.46745 8.53288 3.7061 8.53288 4.00065V7.67057L10.9046 8.85677C11.168 8.98845 11.2751 9.30886 11.1436 9.57227C11.0119 9.83563 10.6915 9.94272 10.4281 9.8112L7.76139 8.47786C7.58071 8.38752 7.46647 8.20266 7.46647 8.00065V4.00065ZM15.1995 8.00065C15.1995 11.9771 11.9761 15.2005 7.99967 15.2005C4.02322 15.2005 0.799805 11.9771 0.799805 8.00065C0.799805 4.0242 4.02322 0.800781 7.99967 0.800781C11.9761 0.800781 15.1995 4.0242 15.1995 8.00065Z" fill="white" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1466_5579">
                            <rect width="16" height="16" fill="white" />
                        </clipPath>
                    </defs>
                </svg>

                12s
                {arrow}
            </div>
        </div>
    </div>
    return (
        <div className={`landing-generate ${secondSection && 'landing-generate--second'}`} data-theme="dark">
            {!secondSection && (

                !isVisible && <div className="landing-generate-slider">
                    <Swiper
                        spaceBetween={0}
                        slidesPerView={'auto'}
                        allowTouchMove={false}
                        speed={12000}
                        loop={true}
                        autoplay={{
                            delay: 0,
                            disableOnInteraction: false,
                        }}
                        freeMode={true}
                        modules={[Autoplay, FreeMode]}

                    >
                        <SwiperSlide style={{ width: "659rem" }}>
                            <div className="landing-generate-slider-wrapper">
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g1.svg`} alt="" />

                                <img src={`${process.env.REACT_APP_BASENAME}/img/g2.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g3.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g4.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g5.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g6.svg`} alt="" />
                            </div>
                        </SwiperSlide>
                        <SwiperSlide style={{ width: "659rem" }}>
                            <div className="landing-generate-slider-wrapper">
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g1.svg`} alt="" />

                                <img src={`${process.env.REACT_APP_BASENAME}/img/g2.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g3.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g4.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g5.svg`} alt="" />
                                <img src={`${process.env.REACT_APP_BASENAME}/img/g6.svg`} alt="" />
                            </div>
                        </SwiperSlide>


                    </Swiper>
                </div>

            )}
            <div className="landing-container">
                <h2>Start with an idea.<br></br>
                    Or none at all.</h2>
                <p>No brief, no editor, no crew — just videos that feel like they were made for a six-figure brand</p>
                <GlassEffect children={typingBlock} />
                <MyButton buttonText={'Generate'} buttonStatus={'white'} onClick={() => handleClick(secondSection ? 'button_23' : 'button_2')} />
            </div>

            {(isVisible && !secondSection) && <div className="landing-generate-slider">
                <Swiper
                    spaceBetween={0}
                    slidesPerView={'auto'}
                    speed={12000}
                    loop={true}
                    autoplay={{
                        delay: 1,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                    }}
                    freeMode={false}
                    modules={[Autoplay, FreeMode]}

                >
                    <SwiperSlide style={{ width: "988rem" }}>
                        <div className="landing-generate-slider-wrapper">
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g1.svg`} alt="" />

                            <img src={`${process.env.REACT_APP_BASENAME}/img/g2.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g3.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g4.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g5.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g6.svg`} alt="" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide style={{ width: "988rem" }}>
                        <div className="landing-generate-slider-wrapper">
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g1.svg`} alt="" />

                            <img src={`${process.env.REACT_APP_BASENAME}/img/g2.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g3.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g4.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g5.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g6.svg`} alt="" />
                        </div>
                    </SwiperSlide>
                    <SwiperSlide style={{ width: "988rem" }}>
                        <div className="landing-generate-slider-wrapper">
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g1.svg`} alt="" />

                            <img src={`${process.env.REACT_APP_BASENAME}/img/g2.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g3.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g4.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g5.svg`} alt="" />
                            <img src={`${process.env.REACT_APP_BASENAME}/img/g6.svg`} alt="" />
                        </div>
                    </SwiperSlide>
                    {/* 
                    <SwiperSlide style={{ width: '92rem' }}>
                        
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '138rem' }}>
                        
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '92rem' }}>
                        
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '126rem' }}>
                        
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '141rem' }}>
                        
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '112rem' }}>
                        
                    </SwiperSlide>

                    <SwiperSlide style={{ width: '92rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g1.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '138rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g2.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '92rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g3.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '126rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g4.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '141rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g5.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '112rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g6.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '92rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g1.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '138rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g2.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '92rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g3.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '126rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g4.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '141rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g5.svg`} alt="" />
                    </SwiperSlide>
                    <SwiperSlide style={{ width: '112rem' }}>
                        <img src={`${process.env.REACT_APP_BASENAME}/img/g6.svg`} alt="" />
                    </SwiperSlide> */}
                </Swiper> </div>}
        </div>
    )
}
